import { useEffect } from 'react'

export const updateDocumentTitle = (title: string, siteName?: string) => {
    const documentTitle = `${title}${(siteName && title) ? ' | ' + siteName : siteName ?? ''}`;
    document.title = documentTitle;
}

const useDocumentTitle = (title: string, siteName?: string) => {
    useEffect(() => {
        updateDocumentTitle(title, siteName)
    }, [title, siteName]);
};

export default useDocumentTitle;